import { HeaderValues } from 'src/Utils/csv/csv.constants'

export const RISK_CSV_TEMPLATE = [
  {
    'Risk ID': 'R-0001',
    Threat: 'This is a sample risk',
    Category: 'Customer Commitments',
    'Predisposing Condition / Vulnerability':
      'This is a sample predisposing condition',
    'Asset at Risk': 'This is a sample asset at risk',
    'Impact to Customer': 'This is a sample impact to customer',
    'Likelihood of Occurrence': 'Very High',
    'Adverse Impact': 'Moderate',
    'Inherent Risk': 'Moderate',
    'Target Impact': 'Moderate',
    'Target Likelihood': 'Low',
    'Residual Risk': 'Low',
    'Current Residual Risk': 'Moderate',
    Status: 'To Do',
    Response: 'Accept',
    'Risk Owner': 'Unassigned',
    'Control IDs': '',
    Notes: '',
    'Created Date': '',
    'Closed Date': '',
  },
  {
    'Risk ID': 'R-0002',
    Threat: 'This is a sample risk',
    Category: 'Laws, Regulations, and Standards',
    'Predisposing Condition / Vulnerability':
      'This is a sample predisposing condition',
    'Asset at Risk': 'This is a sample asset at risk',
    'Impact to Customer': 'This is a sample impact to customer',
    'Likelihood of Occurrence': 'Low',
    'Adverse Impact': 'Moderate',
    'Inherent Risk': 'Low',
    'Target Impact': 'Not Set',
    'Target Likelihood': 'Not Set',
    'Residual Risk': 'Not Set',
    'Current Residual Risk': 'Low',
    Status: 'To Do',
    Response: 'Accept',
    'Risk Owner': 'Unassigned',
    'Control IDs': '',
    Notes: '',
    'Created Date': '',
    'Closed Date': '',
  },
]

export interface ImportRiskCSVRow {
  riskId: string
  threat: string
  category: string
  predisposingCondition: string
  assetAtRisk: string
  impactToCustomer: string
  likelihood: string
  impact: string
  inherentRisk: string
  response: string
  targetImpact: string
  targetLikelihood: string
  residualRisk: string
  currentResidualRisk: string
  riskOwner: string
  status: string
  controlIds: string[]
  notes: string
  createdDate: string
  closedDate: string
}

export const RISK_CSV_HEADERS: HeaderValues[] = [
  {
    input: 'Risk ID',
    output: 'riskId',
  },
  {
    input: 'Threat',
    output: 'threat',
  },
  {
    input: 'Category',
    output: 'category',
    optional: true,
  },
  {
    input: 'Predisposing Condition / Vulnerability',
    output: 'predisposingCondition',
    optional: true,
  },
  {
    input: 'Asset at Risk',
    output: 'assetAtRisk',
    optional: true,
  },
  {
    input: 'Impact to Customer',
    output: 'impactToCustomer',
    optional: true,
  },
  {
    input: 'Likelihood of Occurrence',
    output: 'likelihood',
    optional: true,
  },
  {
    input: 'Adverse Impact',
    output: 'impact',
    optional: true,
  },
  {
    input: 'Inherent Risk',
    output: 'inherentRisk',
    optional: true,
  },
  {
    input: 'Response',
    output: 'response',
    optional: true,
  },
  {
    input: 'Risk Owner',
    output: 'riskOwner',
    optional: true,
  },
  {
    input: 'Target Impact',
    output: 'targetImpact',
    optional: true,
  },
  {
    input: 'Target Likelihood',
    output: 'targetLikelihood',
    optional: true,
  },
  {
    input: 'Residual Risk',
    output: 'residualRisk',
    optional: true,
  },
  {
    input: 'Current Residual Risk',
    output: 'currentResidualRisk',
    optional: true,
  },
  {
    input: 'Status',
    output: 'status',
    optional: true,
  },
  {
    input: 'Control IDs',
    output: 'controlIds',
    optional: true,
  },
  {
    input: 'Notes',
    output: 'notes',
    optional: true,
  },
  {
    input: 'Created Date',
    output: 'createdDate',
    optional: true,
  },
  {
    input: 'Closed Date',
    output: 'closedDate',
    optional: true,
  },
]
